import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { notification } from 'antd';
import { fetchConfig, setSystemConfig, DEFAULT_CONFIG, getMissingConfigKeys } from './slice';
import { SystemConfig } from '~/Types/SystemConfig';
import { RootEpic } from '../types';

// Đường dẫn file config
const PATH_SYSTEM_CONFIG = '/assets/system-config.json';

/** Không throw — chỉ cảnh báo, để tránh URL build ra "undefined/..." mà không ai biết vì sao. */
const warnIfConfigIncomplete = (config: SystemConfig) => {
  const missing = getMissingConfigKeys(config);
  if (missing.length > 0) {
    notification.error({
      message: 'Thiếu cấu hình hệ thống',
      description: `system-config.json thiếu các trường bắt buộc: ${missing.join(', ')}`,
      duration: 0,
    });
  }
};

// Epic để load file system-config.json
const bootstrap$: RootEpic = (action$) =>
  action$.pipe(
    filter(fetchConfig.match),
    switchMap(() =>
      ajax.getJSON<SystemConfig>(PATH_SYSTEM_CONFIG, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      } as any).pipe(
        map((res) => {
          // Cố ý không merge với DEFAULT_CONFIG: field nào thiếu trong JSON phải hiện ra rỗng và bị cảnh báo.
          const config = res as SystemConfig;
          warnIfConfigIncomplete(config);
          return setSystemConfig(config);
        }),
        catchError((error) => {
          // Fallback DEFAULT_CONFIG để không treo mãi ở BootstrapSystem, nhưng vẫn báo lỗi rõ ràng.
          console.error('Không tải được system-config.json:', error);
          notification.error({
            message: 'Không tải được cấu hình hệ thống',
            description: 'Không đọc được /assets/system-config.json, đang dùng cấu hình mặc định (dev).',
            duration: 0,
          });
          return of(setSystemConfig(DEFAULT_CONFIG));
        }),
      )
    )
  );

export const BootstrapEpics = [bootstrap$];

